/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_LabelInputs */

const en_ai_label = /** @type {(inputs: Ai_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI`)
};

const de_ai_label = /** @type {(inputs: Ai_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI`)
};

/**
* | output |
* | --- |
* | "AI" |
*
* @param {Ai_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_label = /** @type {((inputs?: Ai_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_label(inputs)
	return en_ai_label(inputs)
});